module.exports = __webpack_public_path__ + "static/media/2--easy-colour.81a1c4e8.png";